import { baseEnvironment } from './baseEnvironment';

export const environment = {
    ...baseEnvironment,
    apiUrl: 'http://192.85.4.86:3001/api',
    formatArchiveUrl: 'http://192.85.4.86:3000/',
};
